import styled from 'styled-components';
import {
  PrimaryButton,
  SecundaryButton,
} from '@bit/wavfichacerta.fichacerta.shared-styles.buttons';

const pillRadius = `
  &&,
  && button,
  && > * {
    border-radius: 999px !important;
  }
`;

export const ModalFooterPrimaryButton = styled(PrimaryButton)`
  ${pillRadius}
`;

export const ModalFooterSecundaryButton = styled(SecundaryButton)`
  ${pillRadius}
`;
